<template>
  <div class="footer">
    <div class="footercon">
      <div class="footer-logo">
        <img :src="logo" alt="">
      </div>
      <div class="footer-right">
        <div class="footer-tab">
          <div class="tablist" v-for="(item, index) in tabList" :key="index" @click="getTab(index)">{{ item.title }}</div>
        </div>
        <div class="footer-label">
          <div class="footer-textleft">{{ textleft }} </div>
          <div class="footer-textright">公安备案号：贵公网安备52011502000820号，  <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white;text-decoration: none;">黔ICP备18001453号-3</a></div>
        </div>
        <div style="color: white;">
          {{ textright }}
         </div>
      </div>
    </div>
    <div class="footer-top">
      <img :src="footTop" alt="" @click="toTop">
    </div>
  </div>
</template>

<script>
import { getCate } from "@/api/index";
export default {
  name: "DrugFooter",
  data() {
    return {
      logo: "static/images/logo.png",
      footTop: "static/images/home/icon-top.png",
      tabList: [
        {
          title: "网站首页",
          path: "/",
        },
        {
          title: "企业简介",
          path: "/introduce",
        },
        {
          title: "产品中心",
          path: "/production",
          id: null
        },
        {
          title: "新闻资讯",
          path: "/news",
          id: null
        },
        {
          title: "企业公告",
          path: "/notice",
          id: null
        },
        {
          title: "企业文化",
          path: "/culture",
          id: null
        },
        {
          title: "咨询互动",
          path: "/consult",
        }
      ],
      textleft: "贵州汉方药业网站 © 2025 ALL Rights Reserved",
      textright: "建议您使用IE9及以上版本、Chrome、Firefox、360等主流浏览器浏览本网站"
    }
  },
  methods: {
    getTab(index) {
      this.$store.commit("getactive", index);
      if(this.tabList[index].id) {
        this.$store.commit("getpid", this.tabList[index].id);
      } else {
        this.$store.commit("getpid", null);
      }
      this.$router.push({
        path: this.tabList[index].path
      })
    },
    // 回到顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    getCate().then((res) => {
      if(res.data.code == 1) {
        var list = res.data.data;
        for(let i in list) {
          for(let j in this.tabList) {
            if(list[i].name == this.tabList[j].title) {
              this.tabList[j].id = list[i].id;
            }
          }
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    overflow: hidden;
    margin-top: 40px;
    color: #fff;
    background: url("../../static/images/home/icon-footer.png") no-repeat;
    background-size:100% 100%;
    .footercon {
      width: 80%;
      height: 64px;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin: 45px auto 0 auto;
      .footer-logo {
        height: 64px;
        margin: 0 20px;
        img {
          height: 100%;
        }
      }
      .footer-right {
        width: 80%;
        height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .footer-tab {
          width: 90%;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .footer-label {
          width: 100%;
          display: flex;
          .footer-textright {
            margin-left: 20px;
          }
        }
      }
    }
    .footer-top {
      width: 92px;
      height: 115px;
      cursor: pointer;
      margin: 40px auto 20px auto;
      img {
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DrugFooter.vue